import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityDisplay } from "@components/entity/EntityDisplay";
import { AccrualLedgerSettingsRow } from "@components/settings/AccountingSettings/accrualLedgerSettingsUtils";

export const EntityCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, AccrualLedgerSettingsRow, unknown>) => (
        <ViewTableCell>
            <EntityDisplay entity={row.original.entity} />
        </ViewTableCell>
    ),
);
